import { useContext } from "react";
import { ToastContext } from "../context/ToastContext";
import { GroupTypeEnum, UserGroup } from "../models/UserGroup";
import UserGroupService from "../services/crud/UserGroupService";
import { OverlayContext } from "../context/OverlayContext";
import UserGroupForm from "../components/forms/UserGroupForm";
import { Form } from "antd";

export function useUserGroupEditModal({
  itemName,
  onActionComplete,
}: {
  itemName: string,
  onActionComplete: Function
}) {
  const [form] = Form.useForm();
  const { loadMessage } = useContext(ToastContext);
  const { openModal, closeModal } = useContext(OverlayContext);

  const openCreateUserGroup = (accountId: number) => {
    form.resetFields();
    openModal({
    title: `Create ${itemName.toLocaleLowerCase()}`,
    content: <UserGroupForm id={null} update={false} form={form} />,
    onOk: () => {
      form.validateFields().then(async (values) => {
      const payload = {
        ...values,
        accountId: accountId,
        groupType: GroupTypeEnum.APARTMENT,
        description: values.description ?? '',
      }
      loadMessage(
        `Adding ${itemName.toLocaleLowerCase()}...`,
        async () => {
          await UserGroupService.addUserGroup(payload);
          onActionComplete();
        },
      );
      closeModal();
      });
    },
    });
  };
  const openEditUserGroup = (item: {id: number, label: string}) => {
    form.resetFields();
    openModal({
    title: `Update ${itemName.toLocaleLowerCase()} ${item.label}`,
    content: <UserGroupForm id={item.id} update={true} form={form} />,
    onOk: () => {
      form.validateFields().then(async (values) => {
      console.log('payload', values);
      loadMessage(
        `Updating ${itemName.toLocaleLowerCase()}...`,
        async () => {
          await UserGroupService.editUserGroup(item.id, values);
          onActionComplete();
        },
      );
      closeModal();
      });
    },
    });
  };

  return {openCreateUserGroup, openEditUserGroup};
}